<template>
  <footer>
    <div class="copyright">
      <p>©&nbsp;2022 - Castelatto</p>
    </div>
    <div class="credits">
      <div class="designed">
        <small>Layout por: </small>
        <a
          href="http://www.agencialoopers.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="@/assets/loopers.png"
            target="_blank"
            alt="Projetado por&nbsp;Agência Loopers"
          />
        </a>
      </div>
      <div class="developed">
        <small>Desenvolvido por: </small>
        <a
          href="http://sync360.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            width="100"
            src="@/assets/sync360.png"
            target="_blank"
            alt="Desenvolvido por Sync360"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer-component',
}
</script>

<style lang="scss" scoped>
footer {
  background: #000;
  padding: 1rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #fff;
  position: absolute;
  bottom: 0;
  .credits {
    display: flex;
    align-items: center;
    > div {
      display: flex;
      align-items: center;
      &:first-child {
        margin-right: 10px;
      }
      small {
        margin-right: 10px;
      }
    }
  }
  p {
    margin: 0;
  }
}

@media screen and (max-width: 970px) {
  footer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .credits {
      flex-direction: column;
      > div {
        display: flex;
        margin: 10px 0 0;
        align-items: center;
        justify-content: center;
        small {
          margin-right: 10px;
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>